import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=cc2e97ca&scoped=true&"
import script from "./Coin.vue?vue&type=script&lang=js&"
export * from "./Coin.vue?vue&type=script&lang=js&"
import style0 from "./Coin.vue?vue&type=style&index=0&id=cc2e97ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2e97ca",
  null
  
)

export default component.exports